<template>
  <div class="animated fadeIn CreditMemos--CreditMemos-list">
    <fixed-header title="Credit Memos List">
      <template v-slot:center>
        <add-credit-memo v-if="checkClaim(CAN_ADD_CREDIT_MEMO)" @onChange="updateList" @created="updateList"></add-credit-memo>
      </template>
    </fixed-header>
    <div class="card">
      <div class="card-body margin-top-fixed-header" name="card body">
        <b-tabs lazy v-model="tabIndex">
          <b-tab>
            <template v-slot:title>
              Credit Memos <b-badge variant="primary" v-if="tabIndex == 0">{{gridList.length}}</b-badge>
            </template>
            <credit-memo :refreshGrid="refreshGrid"/>
          </b-tab>

          <b-tab>
            <template v-slot:title>
              Refund <b-badge variant="primary" v-if="tabIndex == 1">{{gridList.length}}</b-badge>
            </template>
            <refund-credit-memo :refreshGrid="refreshGrid"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import FixedHeader from '@/shared/components/FixedHeader/index';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
import AddCreditMemo from './components/edit';
import RefundCreditMemo from './components/RefundCreditMemo';
import CreditMemo from './components/CreditMemo';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
	components: {
    FixedHeader,
    DateRangePicker,
    AddCreditMemo,
    RefundCreditMemo,
    CreditMemo
  },
  metaInfo: () => ({
    title: 'CreditMemos',
  }),
	data() {
		return {
      tabIndex: 0,
      refreshGrid: 0
		};
	},
	computed: {
		...mapState('creditMemos', ['lastOpenedId']),
		...mapGetters('creditMemos', [
			'gridList',
		]),
		...mapGetters('account', ['gridSettingsById']),
    isRefund(){
		  return (this.tabIndex == 1) ? true : false;
    }
	},
  methods: {
    updateList(value) {
      if (value == true) {
        this.refreshGrid = 1;
      }
    },
  },
	mounted() {
		// if(this.lastOpenedId) {
		// 	this.selectedRowItemId = this.lastOpenedId;
		// }
    // if('companyName' in this.$route.params) {
    //   this.clearObject(this.filters);
    //   this.filters.companyName = this.$route.params.companyName
    //   this.search(this.filters);
    //   delete this.$route.params.companyName
    // }else {
    //   this.getCreditMemoList()
    // }

    if(this.$route.params.isAdd) {
      this.$bvModal.show('credit-memo-modal');
      delete this.$route.params.isAdd
    }
	},
};
</script>

<style lang="scss">
.CreditMemos {
  &--CreditMemos-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }
}
</style>
